<template>
  <div class="ui container">
    <div class="ui buttons">
      <button class="ui button" @click="date=0;load()" :class="{active: date===0}">上周</button>
      <button class="ui button" @click="date=1;load()" :class="{active: date===1}">本周</button>
      <button class="ui button" @click="date=2;load()" :class="{active: date===2}">上月</button>
      <button class="ui button" @click="date=3;load()" :class="{active: date===3}">本月</button>
    </div>
    <table class="ui celled table">
      <thead>
      <tr>
        <th>排名</th>
        <th>喵币</th>
        <th>头像</th>
        <th>名字</th>
        <th>ID</th>
      </tr>
      </thead>
      <tbody>
      <tr v-for="star in stars">
        <td>{{ star.sort }}</td>
        <td>{{ star.mb_num }}</td>
        <td>
          <router-link :to="'/mm/stars/'+star.starid"><img class="ui tiny image" :src="star.head_img"></router-link>
        </td>
        <td>
          <router-link :to="'/mm/stars/'+star.starid">{{ star.star_name }}</router-link>
        </td>
        <td>
          <router-link :to="'/mm/stars/'+star.starid">{{ star.starid }}</router-link>
        </td>
      </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import axios from 'axios'

export default {
  name: 'StarList',
  data () {
    return {
      date: 1,
      stars: []
    }
  },
  mounted () {
    this.load()
  },
  methods: {
    load () {
      axios.get('/mm/stars?date=' + this.date).then(({ data }) => {
        this.stars = data.data
      })
    }
  }
}
</script>

<style scoped>

</style>
